// Libraries
import { gql } from "@/Common/context/subscriptions/Subscriptions";

const onUpdateMappedCustomFields = gql`
	subscription onUpdateMappedCustomFields($locationId: String) {
		onUpdateMappedCustomFields(locationId: $locationId) {
			locationId
			mappedCustomFields {
				_id
				systemCustomField
				payrollCustomFields {
					displayId
					companyId
					fieldId
					fieldName
				}
			}
		}
	}
`;

const onUpdateMappedPayItems = gql`
	subscription onUpdateMappedPayItems($locationId: String) {
		onUpdateMappedPayItems(locationId: $locationId) {
			locationId
			mappedPayItems {
				_id
				systemPayItem
				payrollPayItems {
					displayId
					companyId
					componentId
					name
				}
				type
				hoursMemo
			}
		}
	}
`;

const onUpdateCustomFieldDefinitions = gql`
	subscription onUpdateCustomFieldDefinitions($locationId: String) {
		onUpdateCustomFieldDefinitions(locationId: $locationId) {
			locationId
		}
	}
`;
const onUpdatePayItemsOptions = gql`
	subscription onUpdatePayItemsOptions($locationId: String) {
		onUpdatePayItemsOptions(locationId: $locationId) {
			locationId
			status
			updatedAt
		}
	}
`;
export { onUpdateMappedCustomFields, onUpdateMappedPayItems, onUpdateCustomFieldDefinitions, onUpdatePayItemsOptions };
